// circlePolygon approximates a circle of radius meters as a GeoJSON polygon.
// MapLibre's circle layer sizes circles in pixels, so accuracy and place
// radii are drawn as polygons to stay true to the ground at every zoom.
export function circlePolygon(lat: number, lon: number, meters: number, steps = 48): GeoJSON.Polygon {
  const coords: [number, number][] = [];
  const latRad = (lat * Math.PI) / 180;
  const dLat = meters / 111_320;
  const dLon = meters / (111_320 * Math.max(Math.cos(latRad), 0.01));
  for (let i = 0; i <= steps; i++) {
    const a = (i / steps) * 2 * Math.PI;
    coords.push([lon + dLon * Math.cos(a), lat + dLat * Math.sin(a)]);
  }
  return { type: 'Polygon', coordinates: [coords] };
}

// initials returns up to two letters for a member's map marker.
export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

// distanceM is the great-circle distance between two points in meters.
export function distanceM(lat1: number, lon1: number, lat2: number, lon2: number): number {
  const r = 6_371_000;
  const toRad = Math.PI / 180;
  const dLat = (lat2 - lat1) * toRad;
  const dLon = (lon2 - lon1) * toRad;
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(lat1 * toRad) * Math.cos(lat2 * toRad) * Math.sin(dLon / 2) ** 2;
  return 2 * r * Math.asin(Math.sqrt(a));
}

// eastOf returns the longitude meters east of a point, where a place's radius
// handle sits.
export function eastOf(lat: number, lon: number, meters: number): number {
  return lon + meters / (111_320 * Math.max(Math.cos((lat * Math.PI) / 180), 0.01));
}
